import { render, staticRenderFns } from "./LiveTutorialFieldsTranslation.vue?vue&type=template&id=66ed1850"
import script from "./LiveTutorialFieldsTranslation.vue?vue&type=script&lang=js"
export * from "./LiveTutorialFieldsTranslation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports